import { render, staticRenderFns } from "./timeline-ghost-item.vue?vue&type=template&id=57dfc216&"
import script from "./timeline-ghost-item.vue?vue&type=script&lang=js&"
export * from "./timeline-ghost-item.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports